module.exports = __webpack_public_path__ + "static/media/find-a-cofounder-or-partner.87f87e66.svg";